import urlConstants from '~/lib/constants/url.constants';

import api from './api';

const {
  chat: {
    getChatToken: chatTokenUrl,
    channelRotate,
    sendbirdProxy: { getGroupChannelMessages, getGroupChannelsByPatientId },
  },
} = urlConstants;

type GetGroupChannelsByPatientIdResponse = { channels: any[] };
type GetGroupChannelsByPatientIdRequest = { patientId: string };

type GetGroupChannelMessagesResponse = { messages: any[] };
type GetGroupChannelMessagesRequest = {
  channel_url: string;
  prev_limit: number;
  next_limit: number;
  message_ts: number;
};

export const chatApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGroupChannelMessages: build.query<
      GetGroupChannelMessagesResponse,
      GetGroupChannelMessagesRequest
    >({
      query: ({ channel_url, prev_limit, next_limit, message_ts }) =>
        getGroupChannelMessages(
          channel_url,
          prev_limit,
          next_limit,
          message_ts,
        ),
    }),
    getGroupChannelsByPatientId: build.query<
      GetGroupChannelsByPatientIdResponse,
      GetGroupChannelsByPatientIdRequest
    >({
      query: ({ patientId }) => getGroupChannelsByPatientId(patientId),
    }),
    rotateChannel: build.mutation<string, { channelUrl: string }>({
      query: ({ channelUrl }) => ({
        body: {},
        method: 'POST',
        responseHandler: 'text',
        url: channelRotate(channelUrl),
      }),
    }),
    getUserChatToken: build.query<SendBirdApiToken, void>({
      query: () => chatTokenUrl,
      extraOptions: {
        maxRetries: 2, // Will retry 2 times, for 3 total attempts
      },
    }),
  }),
});

export const {
  useLazyGetUserChatTokenQuery,
  useRotateChannelMutation,
  useLazyGetGroupChannelMessagesQuery,
  useLazyGetGroupChannelsByPatientIdQuery,
} = chatApi;
